import axios from "axios";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";
import NotFound from "../components/NotFound";
import { API_URL } from "../config";

import moment from "moment";
import { useTranslation } from "next-i18next";
// import Datetime from "react-datetime";
// import "react-datetime/css/react-datetime.css";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { cn } from "@/lib/utils";
import { FaRegCalendarAlt } from "react-icons/fa";
import { formatDate, trim } from "../helpers/helperFunctions";
import Loader from "./Loader";
import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import { DialogFooter } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Switch } from "./ui/switch";

interface IDetailValues {
  strategyId: number;
  submit: any;
  success: any;
  error: any;
  live?: Boolean;
  deployType?: string;
  deployVirtually?: any;
  setModal?: any;
  isCrypto?: boolean;
}
const AddOns: any = (props: IDetailValues) => {
  const { t } = useTranslation("add-ons-form");
  const { data: session } = useSession();
  const { subscriptionData } = useSubscription();
  const router = useRouter();
  const { id } = router.query;
  const [userInfo, setUserInfo] = useState<any>(null);
  const [error, setError] = useState("");
  const [selectedTimezone, setSelectedTimezone] = useState<
    string | undefined
  >();
  const [loading, setLoading] = useState(false);
  const [daySwitch, setDaySwitch] = useState(false);
  const [timeSwitch, setTimeSwitch] = useState(false);
  const [mobileNotifications, setMobileNotifications] = useState(false);
  const [webhook, setWebhook] = useState(false);
  const [strategyExpiration, setStrategyExpiration] = useState(false);
  const [changeTimeframe, setChangeTimeframe] = useState(false);
  const [killSwitch, setKillSwitch] = useState(false);
  const [profitShutdown, setProfitShutdown] = useState(false);
  const [lossShutdown, setLossShutdown] = useState(false);
  const [positionBuilder, setPositionBuilder] = useState(false);
  const [coolDownPeriod, setCoolDownPeriod] = useState(false);
  const [switchDays, setSwitchDays] = useState<any>([]);
  const [data, setData] = useState<any>({});
  const [strategyId] = useState<any>(props.strategyId);
  const [errors, setErrors] = useState<any>({});
  const [showTimeZones, setShowTZs] = useState(false);
  const [showStrExp, setShowStrExp] = useState(false);
  const [selectedStrExp, setSelectedStrExp] = useState<Date | undefined>();

  const isNextDay = (startTime: string, endTime: string): boolean => {
    const [startHour, startMinute] = startTime.split(":").map(Number);
    const [endHour, endMinute] = endTime.split(":").map(Number);

    return (
      startHour > endHour || (startHour === endHour && startMinute > endMinute)
    );
  };
  const weekDays = useMemo(
    () => [
      {
        label: t("week.sun"),
        val: 0,
      },
      {
        label: t("week.mon"),
        val: 1,
      },
      {
        label: t("week.tue"),
        val: 2,
      },
      {
        label: t("week.wed"),
        val: 3,
      },
      {
        label: t("week.thu"),
        val: 4,
      },
      {
        label: t("week.fri"),
        val: 5,
      },
      {
        label: t("week.sat"),
        val: 6,
      },
    ],
    []
  );
  const todayDate = useMemo(() => {
    let x = new Date();
    x.setHours(24, 0, 0, 0);
    return x;
  }, []);
  const addToData = useCallback((type: string, val: string) => {
    setData((prev: typeof data) => ({ ...prev, [type]: val }));
  }, []);
  const setAuthHeader = (token: string) => {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  };
  useEffect(() => {
    const u = JSON.parse(localStorage.getItem("user-info")!);
    setUserInfo(u);
  }, [id]);
  if (!session && !userInfo) {
    return false;
  }
  if (error) {
    return <NotFound />;
  }

  const clearErrors = () => {
    setErrors({});
  };

  const saveChanges = () => {
    const data2 = JSON.parse(JSON.stringify(data));
    if (!daySwitch) {
      delete data2["day_switch"];
    }
    if (!timeSwitch) {
      delete data2["startTime"];
      delete data2["endTime"];
    }
    if (!mobileNotifications) {
      // data2["mobile_notification"] = "off";
    } else {
      data2["mobile_notification"] = "on";
    }
    if (!webhook) {
      delete data2["webhook"];
    }
    if (!changeTimeframe) {
      delete data2["instruments_input"];
      delete data2["timeframe"];
    }
    if (!strategyExpiration) {
      delete data2["strategy_expiration"];
    }
    if (!killSwitch) {
      delete data2["killSwitch"];
    }
    if (!profitShutdown) {
      delete data2["profit"];
    }
    if (!lossShutdown) {
      delete data2["loss"];
    }
    if (!positionBuilder) {
      delete data2["tp"];
      delete data2["sl"];
    }
    if (!coolDownPeriod) {
      delete data2["cooldown_period"];
    }
    data2["timezone"] = selectedTimezone;
    clearErrors();
    let errs: any = {};
    if (
      daySwitch &&
      (data2["day_switch"] == undefined ||
        JSON.parse(data2["day_switch"]).length == 0)
    ) {
      errs["day_switch"] = "Please select values for day Switch";
    }
    if (
      timeSwitch &&
      (data2["startTime"] == undefined || trim(data2["startTime"]).length == 0)
    ) {
      errs["startTime"] = "Please select a start time";
    }
    if (
      timeSwitch &&
      (data2["endTime"] == undefined || trim(data2["endTime"]).length == 0)
    ) {
      errs["endTime"] = "Please select an end time";
    }
    if (
      webhook &&
      (data2["webhook"] == undefined || trim(data2["webhook"]).length == 0)
    ) {
      errs["webhook"] = "Please select a webhook";
    }
    if (strategyExpiration) {
      if (
        data2["strategy_expiration"] == undefined ||
        trim(data2["strategy_expiration"]).length == 0
      )
        errs["strategy_expiration"] = "Please select strategy expiration date.";
      else {
        let date = moment(data2["strategy_expiration"], "DD/MM/yyyy"),
          today = moment();
        today.hours(24);
        today.minutes(0);
        today.seconds(0);
        today.milliseconds(-1);
        date.hours(24);
        date.minutes(0);
        date.seconds(0);
        date.milliseconds(-1);
        if (date.isBefore(today)) {
          errs["strategy_expiration"] =
            "Please select current or future date for expiration date";
        }
      }
    }
    if (
      killSwitch &&
      (data2["killSwitch"] == undefined || data2["killSwitch"].length == 0)
    ) {
      errs["killSwitch"] =
        "Please select a valid trade limit for the strategy.";
    }
    if (
      profitShutdown &&
      (data2["profit"] == undefined ||
        data2["profit"].length == 0 ||
        isNaN(parseFloat(data2["profit"])) ||
        parseFloat(data2["profit"]) <= 0)
    ) {
      errs["profit"] = "Please enter a valid profit Shutdown value.";
    }
    if (
      lossShutdown &&
      (data2["loss"] == undefined ||
        data2["loss"].length == 0 ||
        isNaN(parseFloat(data2["loss"])) ||
        parseFloat(data2["loss"]) <= 0)
    ) {
      errs["loss"] = "Please enter a valid stop loss value.";
    }
    if (
      positionBuilder &&
      (data2["tp"] == undefined ||
        data2["tp"].length == 0 ||
        isNaN(parseFloat(data2["tp"])) ||
        parseFloat(data2["tp"]) <= 0)
    ) {
      errs["tp"] = "Required field";
    }
    if (
      positionBuilder &&
      (data2["sl"] == undefined ||
        data2["sl"].length == 0 ||
        isNaN(parseFloat(data2["sl"])) ||
        parseFloat(data2["sl"]) <= 0)
    ) {
      errs["sl"] = "Required field";
    }
    if (
      coolDownPeriod &&
      (data2["cooldown_period"] == undefined ||
        data2["cooldown_period"].length == 0 ||
        isNaN(parseFloat(data2["cooldown_period"])) ||
        parseFloat(data2["cooldown_period"]) <= 0)
    ) {
      errs["cooldown_period"] = "Required field";
    }
    setErrors(errs);
    if (Object.keys(errs).length != 0) {
      props.error("Please fill the required fields.");
      return false;
    }
    setLoading(true);
    let url = new URL("save_addons", API_URL);
    url.searchParams.append("add_ons", JSON.stringify(data2).toString());
    url.searchParams.append("user_id", userInfo.user_id as string);
    url.searchParams.append("strategy_id", strategyId);

    axios
      .post(url.toString(), {}, setAuthHeader(userInfo.token))
      .then((res: any) => {
        if (res?.status == 200) {
          props.success(res);
          if (props?.live) {
            // props.submit(4);
            router.push(
              `/deploy-live/${strategyId}?locale=${router.query.locale || "en"}`
            );
          } else if (props?.deployType === "virtual") {
            props?.deployVirtually();
            props.setModal(false);
            setLoading(false);
          } else {
            setLoading(false);
            props.submit(2);
          }
        } else {
          setLoading(false);
          props.error(res?.data2?.detail || "Error updating Addons.");
        }
      })
      .catch((e) => {
        console.error(e);
        props.error(e.message || "Error updating addons.");
        setLoading(false);
      });
  };

  const handleSkip = () => {
    if (props?.deployType === "live") {
      router.push(
        `/deploy-live/${strategyId}?locale=${router.query.locale || "en"}`
      );
    } else if (props?.deployType === "virtual") {
      router.push(
        `/deploy-virtual/${strategyId}?locale=${router.query.locale || "en"}`
      );
      props.setModal(false);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const toggleDay = (val: any) => {
    let sd;
    if (switchDays.includes(val)) {
      sd = switchDays.filter((d: any) => d != val);
      setSwitchDays(sd);
      addToData("day_switch", JSON.stringify(sd));
    } else {
      sd = [...switchDays, val];
      setSwitchDays(sd);
      addToData("day_switch", JSON.stringify(sd));
    }
  };

  return (
    <>
      <div className="flex flex-col gap-4 my-3  sm:max-h-[calc(100vh-250px)]  pr-1">
        <div className="flex flex-row flex-wrap md:flex-nowrap gap-4 gap-x-10">
          <div className="w-full flex flex-col gap-2">
            <div className="flex flex-row justify-between items-center ">
              <div>
                <div>{t("daySwitch")}</div>
                <div className="text-sm text-muted-foreground">
                  {t("switchStrategyDay")}
                </div>
              </div>
              <Switch
                checked={daySwitch}
                onCheckedChange={(val) => {
                  setDaySwitch(val);
                  if (val) {
                    const allDays = weekDays.map((day) => day.val);
                    setSwitchDays(allDays);
                    addToData("day_switch", JSON.stringify(allDays));
                  } else {
                    setSwitchDays([]);
                    addToData("day_switch", JSON.stringify([]));
                  }
                }}
              />
            </div>
            {daySwitch && (
              <>
                <div>
                  <div className="flex flex-wrap gap-2">
                    {weekDays.map((day, idx) => (
                      <Button
                        key={idx}
                        disabled={idx === 6 || idx === 0}
                        variant="outline"
                        className={cn(
                          switchDays.includes(day.val)
                            ? "bg-[--marketplace-blue]"
                            : "",
                          "hover:bg-[--marketplace-blue]"
                        )}
                        onClick={() => toggleDay(day.val)}
                      >
                        {day.label}
                      </Button>
                    ))}
                  </div>
                </div>
                {errors && errors.day_switch !== "undefined" && (
                  <div className="text-destructive">{errors?.day_switch}</div>
                )}
              </>
            )}
          </div>
          <div className="w-full">
            <div className="flex flex-row justify-between items-center">
              <div>
                <div>{t("timeSwitch")}</div>
                <div className="text-sm text-muted-foreground">
                  {t("switchStrategyTime")}
                </div>
              </div>
              <Switch
                checked={timeSwitch}
                onCheckedChange={(val) => setTimeSwitch(val)}
              />
            </div>
            {timeSwitch && (
              <div className="w-full flex flex-col gap-2 mt-2">
                <div className="flex flex-col gap-2">
                  <Label>{t("startTime")} (UTC)</Label>
                  <Input
                    type="time"
                    onChange={(e) => addToData("startTime", e.target.value)}
                  />
                  {errors && errors["startTime"] !== "undefined" && (
                    <div className="text-destructive">
                      {errors["startTime"]}
                    </div>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <Label>{t("endTime")} (UTC)</Label>
                  <Input
                    type="time"
                    onChange={(e) => addToData("endTime", e.target.value)}
                  />
                  {errors && errors["endTime"] !== "undefined" && (
                    <div className="text-destructive">{errors["endTime"]}</div>
                  )}
                </div>

                {/* ✅ Conditional label */}
                {data?.startTime &&
                  data?.endTime &&
                  isNextDay(data.startTime, data.endTime) && (
                    <div className="text-sm text-muted-foreground italic">
                      {t(`${data?.endTime} will be of the next day`)}
                    </div>
                  )}
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-row flex-wrap md:flex-nowrap gap-4 gap-x-10">
          <div className="w-full">
            <div className="flex flex-row justify-between items-center">
              <div>
                <div>{t("strategyExpiration")}</div>
                <div className="text-sm text-muted-foreground">
                  {t("automaticallyKill")}
                </div>
              </div>
              <Switch
                checked={strategyExpiration}
                onCheckedChange={(val) => setStrategyExpiration(val)}
              />
            </div>
            {strategyExpiration && (
              <div className="flex flex-col gap-2 mt-2">
                <Popover open={showStrExp} onOpenChange={setShowStrExp}>
                  <PopoverTrigger asChild>
                    <Button
                      variant={"outline"}
                      className={cn(
                        "pl-3 text-left font-normal w-full",
                        !selectedStrExp && "text-muted-foreground"
                      )}
                    >
                      {selectedStrExp ? (
                        formatDate(selectedStrExp, "DD-MMM-YY")
                      ) : (
                        <span>Pick a date</span>
                      )}
                      <FaRegCalendarAlt className="ml-auto h-4 w-4 opacity-50" />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                      mode="single"
                      selected={selectedStrExp}
                      fromDate={todayDate}
                      onSelect={(e) => {
                        addToData(
                          "strategy_expiration",
                          moment(e).format("DD/MM/yyyy")
                        );
                        setSelectedStrExp(e);
                        setShowStrExp(false);
                      }}
                    />
                  </PopoverContent>
                </Popover>
                {errors && errors["strategy_expiration"] !== "undefined" && (
                  <div className="text-destructive">
                    {errors["strategy_expiration"]}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="w-full">
            <div className="flex flex-row justify-between items-center">
              <div className="">
                <div className="dark:text-white dark:opacity-80">
                  {t("killSwitch")}
                </div>
                <div className="text-sm text-muted-foreground">
                  {t("turnOffStrategy")}.
                </div>
              </div>
              <Switch
                checked={killSwitch}
                onCheckedChange={(val) => setKillSwitch(val)}
              />
            </div>
            {killSwitch && (
              <div className="flex flex-col gap-2 mt-2">
                <Input
                  name="killSwitch"
                  autoComplete="off"
                  onChange={(e) =>
                    addToData("killSwitch", e.currentTarget.value)
                  }
                  placeholder="Kill Switch Value"
                  min={1}
                  type="number"
                />
                {errors && errors["killSwitch"] !== "undefined" && (
                  <div className="text-destructive">{errors["killSwitch"]}</div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-row flex-wrap md:flex-nowrap gap-4 gap-x-10">
          <div className="w-full">
            <div className="flex flex-row justify-between items-center">
              <div>
                <div>{t("profitSatisfaction")}</div>
                <div className="text-sm text-muted-foreground">
                  {t("turnOffStrategyMaxProfit")}.
                </div>
              </div>
              <Switch
                checked={profitShutdown}
                onCheckedChange={(val) => setProfitShutdown(val)}
              />
            </div>
            {profitShutdown && (
              <div className="flex flex-col gap-2 mt-2">
                <div className="flex flex-row gap-2">
                  <Input
                    name="profit"
                    autoComplete="off"
                    onChange={(e) => {
                      {
                        addToData("profit", e.currentTarget.value);
                      }
                    }}
                    min={1}
                    placeholder="Profit satisfaction shutdown"
                    type="number"
                  />
                </div>
                {errors && errors["profit"] !== "undefined" && (
                  <div className="text-destructive">{errors["profit"]}</div>
                )}
              </div>
            )}
          </div>
          <div className="w-full">
            <div className="flex flex-row justify-between items-center">
              <div>
                <div>{t("lossRealization")}</div>
                <div className="text-sm text-muted-foreground">
                  {t("turnOffStrategyMaxLoss")}.
                </div>
              </div>
              <Switch
                checked={lossShutdown}
                onCheckedChange={(val) => setLossShutdown(val)}
              />
            </div>
            {lossShutdown && (
              <div className="flex flex-col gap-2 mt-2">
                <div className="flex flex-row items-center">
                  <Input
                    name="loss"
                    onChange={(e) => {
                      {
                        addToData("loss", e.currentTarget.value);
                      }
                    }}
                    min={1}
                    autoComplete="off"
                    placeholder="Loss realization shutdown"
                    type="number"
                  />
                </div>
                {errors && errors["loss"] !== "undefined" && (
                  <div className="text-destructive">{errors["loss"]}</div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-row flex-wrap md:flex-nowrap gap-4 gap-x-10"></div>
      </div>
      <DialogFooter className="flex justify-end gap-4">
        <Button variant={"default"} onClick={() => handleSkip()}>
          {t("Skip for now")}
        </Button>
        <Button
          onClick={() => saveChanges()}
          className="flex gap-2 bg-[--marketplace-blue] text-primary-foreground"
          disabled={loading}
        >
          {props?.deployType === "virtual" ? t("deploy") : t("next")}{" "}
          {loading && <Loader />}
        </Button>
      </DialogFooter>
    </>
  );
};

export default AddOns;
